export const translations = {
  exchangable: "Nombre del producto canjeable",
  specification: "Especificaciones del producto",
  restrictionsAndDetails: "Detalles y restricciones del canje",
  value: "Valor en AllSport coins",
  dueDate: "Válido hasta",
};
